import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex align-items-center gap-5" }
const _hoisted_4 = { class: "card mt-10" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "d-flex align-items-center gap-5" }

import { ref } from "vue";
import ItServices from "../services/ItServices";


export default /*#__PURE__*/_defineComponent({
  __name: 'TranslationIndex',
  setup(__props) {

const clientAddress = ref<string>(
  "/Users/CatFly/Documents/Projects/client/src/locales/"
);
const webAddress = ref<string>(
  "/Users/CatFly/Documents/Projects/web/resources/lang/"
);
const webFileName = ref<string>("theBCR.php");
const webInput = ref<string>("");
const webArray = ref<any>([]);
const isLoading = ref(false);

const submitClient = async () => {
  isLoading.value = true;
  try {
    await ItServices.updateClientTranslation({ address: clientAddress.value });
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const submitWeb = async () => {
  isLoading.value = true;
  try {
    if (webInput.value) {
      webArray.value = webInput.value.trim().split(",");
    }
    await ItServices.updateWebTranslation({
      address: webAddress.value,
      fileName: webFileName.value,
      translateArray: webArray.value.length > 0 ? webArray.value : null,
    });
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const clientLinks = ref({
  "Kay's Client": "/Users/CatFly/Documents/Projects/client/src/locales",
});

const webLinks = ref({
  "Kay's Web": "/Users/CatFly/Documents/Projects/web/resources/lang/",
});

const clientChange = (link: string) => {
  clientAddress.value = link;
};

const webChange = (link: string) => {
  webAddress.value = link;
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            disabled: isLoading.value,
            modelValue: clientAddress.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((clientAddress).value = $event)),
            placeholder: "lang folder address",
            class: "w-400px"
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: isLoading.value,
            onClick: submitClient,
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Update Client")
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientLinks.value, (link, key) => {
          return (_openBlock(), _createBlock(_component_el_button, {
            type: "success",
            class: "mt-5",
            plain: "",
            disabled: isLoading.value,
            key: key,
            onClick: ($event: any) => (clientChange(link))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(key), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            placeholder: "specific array key to update",
            disabled: isLoading.value,
            modelValue: webInput.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((webInput).value = $event)),
            class: "w-400px mb-4"
          }, null, 8, ["disabled", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_input, {
            disabled: isLoading.value,
            modelValue: webAddress.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((webAddress).value = $event)),
            placeholder: "lang folder address",
            class: "w-400px"
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(_component_el_input, {
            modelValue: webFileName.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((webFileName).value = $event)),
            class: "w-150px",
            disabled: isLoading.value
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_el_button, {
            type: "warning",
            loading: isLoading.value,
            onClick: submitWeb,
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Update Web")
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(webLinks.value, (link, key) => {
          return (_openBlock(), _createBlock(_component_el_button, {
            type: "success",
            class: "mt-5",
            plain: "",
            disabled: isLoading.value,
            key: key,
            onClick: ($event: any) => (webChange(link))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(key), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})